import { FreeCota, Getter, Setter, Store } from '@types'
import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz')

export const createFreeCotaActions = (set: Setter, get: Getter) => ({
  addFreeMeasurement: (start: [number, number], end: [number, number]) => {
    const id = `freeCota_${nanoid(22)}`
    const newCota: FreeCota = { id, start, end }
    set((store: Store) => {
      const prev = store.freeMeasurements ?? new Map<string, FreeCota>()
      store.freeMeasurements = new Map(prev)
      store.freeMeasurements.set(id, newCota)
      store.freeCotaStartPoint = null
      store.freeCotaPreviewEnd = null
    })
    return id
  },

  setFreeCotaStartPoint: (point: [number, number] | null) => {
    set((store: Store) => {
      store.freeCotaStartPoint = point
      store.freeCotaPreviewEnd = null
    })
  },

  setFreeCotaPreviewEnd: (point: [number, number] | null) => {
    set((store: Store) => {
      store.freeCotaPreviewEnd = point
    })
  },

  setSelectedFreeCotaId: (id: string | null, clickPosition?: { x: number; y: number } | null) => {
    set((store: Store) => {
      store.selectedFreeCotaId = id
      store.selectedFreeCotaClickPosition = id && clickPosition ? clickPosition : null
    })
  },

  deleteFreeMeasurement: (id: string) => {
    set((store: Store) => {
      if (store.freeMeasurements) store.freeMeasurements.delete(id)
      if (store.selectedFreeCotaId === id) {
        store.selectedFreeCotaId = null
        store.selectedFreeCotaClickPosition = null
      }
    })
  },

  clearAllFreeMeasurements: () => {
    set((store: Store) => {
      if (store.freeMeasurements) store.freeMeasurements.clear()
      store.freeCotaStartPoint = null
    })
  },
})
